import React from 'react'
import { connect } from 'react-redux'
import ExportBtn from './ExportBtn'
import ResetBtn from './ResetBtn'
import NavBtn from './NavBtn'
import UpdateBtn from './UpdateBtn'
import PartView from './PartView'
import PositionInfo from '../components/PositionInfo'
import * as actions from '../actions'
import { AppState, ImagePosition } from '../reducers'
import { AppMode } from '../constants'
import { Product, getSelectedProduct } from '../services/assortment.service'

class View extends React.Component<ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>> {
	render() {
		const { props } = this
		let { config } = props

		return (
			<div id="kr-view" style={
				config.canvasBackground.customBackground ? {
					backgroundImage: "url('" + config.canvasBackground.path + "')",
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 100%"
				} : {}
			}>
				<div id="kr-top" style={{ display: 'none' }}>
					{config.appMode === AppMode.Editor ? <UpdateBtn /> : <NavBtn />}
				</div>
				<PartView />
				{config.appMode === AppMode.Preview ? null : <div id="kr-bottom">
					{config.appMode === AppMode.Editor && <><UpdateBtn /> <PositionInfo position={props.selectedPosition} /></>}
					{config.appMode === AppMode.Order && !config.newOrderApplication && <div onClick={props.resetOrder}>
						<img src={`${config.iconsPath}close.png`} alt="X" />
						<div>Zeruj zamówienie</div>
					</div>}
					{config.appMode === AppMode.Order && <p className="kr-ExportBtnNotification">Zaktualizowano produkty w koszyku</p>}
					{config.appMode === AppMode.Order && config.newOrderApplication && <ResetBtn />}
					{config.appMode === AppMode.Order && <ExportBtn />}
				</div>}
			</div>
		)
	}
}

const mapStateToProps = (state: AppState) => {
	let pos: ImagePosition = null
	let prd: Product | null = getSelectedProduct();
	if (state.config.appMode === AppMode.Editor) {
		if (prd) {
			pos = {
				x: prd.posX,
				y: prd.posY,
				z: prd.posZ,
			}
		}
			
	}
	return {
		config: state.config,
		selectedPosition: pos,
	}
}

const mapDispatchToProps = dispatch => ({
    resetOrder: () => {
        dispatch(actions.resetOrder())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(View)
